export default __webpack_public_path__ + "f16b9338d96830f609a3415bab15cd0e.jpg";